/**
 * Six-digit hex colour parse pattern, with the leading `#` optional and the three channel pairs captured in order.
 *
 * Case-INSENSITIVE by flag rather than by an `A-Fa-f` class, because both consumers feed `exec` results straight into
 * `parseInt(_, 16)`, which is itself case-blind -- widening the class instead would change nothing at the call sites
 * while making the two spellings diverge on sight. NO `/g`: every consumer calls `.exec` once per value, and a `g` flag
 * would leak `lastIndex` across calls and miss every second colour.
 */

/** `#?RRGGBB` with the three channel pairs captured; case-insensitive, un-anchored-to-global by design. */
export const HEX_COLOR_PATTERN = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i;
